/*
  innvolo-cotizador.js
  Cotizador de la home. Diseño aprobado el 2026-07-26.

  DE DÓNDE SALEN LOS NÚMEROS
  Ninguno está escrito aquí. Todos llegan en el JSON que imprime
  sections/innvolo-cotizador.liquid, y ese JSON se arma leyendo:

    · metaobject innvolo_parametros_precio  → margen, cantidad base y los 6 descuentos
    · metaobject tecnica_marcacion          → nombre y costo por unidad de cada técnica
    · producto.price                        → precio de la prenda a la cantidad base
    · innvolo.tecnicas_permitidas           → qué técnicas admite cada producto

  Lo único que vive en este archivo es la ARITMÉTICA de D-016, que es la misma
  del Excel del negocio:

    producto  = precio_base × (1 − desc_producto(cantidad))
    marcación = costo_tecnica × (1 − desc_marcacion(cantidad))
    unitario  = producto + marcación

  Si el dueño cambia el margen o un descuento en el admin, esto lo refleja sin
  tocar código. Cuando llegue el motor de FastAPI (Fase 3) sustituye a `calcula`
  y el resto del archivo sigue igual.
*/

(function () {
  'use strict';

  var raiz = document.querySelector('[data-innvolo-cotizador]');
  if (!raiz) return;

  var fuente = raiz.querySelector('[data-innvolo-datos]');
  if (!fuente) return;

  var DATOS;
  try {
    DATOS = JSON.parse(fuente.textContent);
  } catch (e) {
    return;
  }

  var PROD = DATOS.productos || [];
  var TEC = DATOS.tecnicas || {};
  var TOPES = DATOS.topes || [20, 50, 100, 500];
  var DESC = DATOS.descuentos || { producto: {}, marcacion: {} };

  if (!PROD.length) return;

  /* Muestras de color. Son la traducción del nombre de la opción de variante a
     un color de pantalla: no es un dato de negocio, es presentación. */
  var COLORES = {
    Negro: '#151a20',
    Blanco: '#fafafa',
    Azul: '#1b3e86',
    Gris: '#98a2ae',
    Rojo: '#b0302f',
    Verde: '#1f6b44',
    Amarillo: '#d8b520',
    Morado: '#5b2e8c',
    Beige: '#d9cdb8',
    'Café': '#6b4630',
    Plateado: '#c9ccd1',
    Transparente: '#dce6ee'
  };
  var ARCOIRIS = 'linear-gradient(135deg,#1b3e86,#b0302f,#d8b520)';

  var fmt = new Intl.NumberFormat('es-CO', { maximumFractionDigits: 0 });
  var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel) {
    return raiz.querySelector(sel);
  }
  function cop(n) {
    return '$' + fmt.format(Math.round(n));
  }

  /* --- D-016: dos curvas independientes, ambas sobre el precio de la base --- */
  function escalonDe(tabla, q) {
    var d = 0;
    for (var i = 0; i < TOPES.length; i++) {
      if (q >= TOPES[i] && tabla[TOPES[i]] != null) d = tabla[TOPES[i]];
    }
    return d;
  }
  function descProducto(q) {
    return escalonDe(DESC.producto, q);
  }
  function descMarcacion(q) {
    return escalonDe(DESC.marcacion, q);
  }

  function calcula(prod, q, clave) {
    var prenda = prod.p * (1 - descProducto(q));
    var marca = clave && TEC[clave] ? TEC[clave].c * (1 - descMarcacion(q)) : 0;
    return { prenda: prenda, marca: marca, unit: prenda + marca };
  }

  /* ------------------------------------------------------------------ */

  var estado = { h: PROD[0].h, q: TOPES[0], k: PROD[0].k[0] || null };

  function porHandle(h) {
    for (var i = 0; i < PROD.length; i++) {
      if (PROD[i].h === h) return PROD[i];
    }
    return null;
  }
  function actual() {
    return porHandle(estado.h) || PROD[0];
  }

  var sel = $('[data-innvolo-producto]');
  var campo = $('[data-innvolo-cantidad]');
  var rango = $('[data-innvolo-rango]');
  var topes = $('[data-innvolo-topes]');
  var tecnicas = $('[data-innvolo-tecnicas]');
  var escalera = $('[data-innvolo-escalera]');

  /* --- selector de producto, agrupado por categoría --- */
  var cats = [];
  PROD.forEach(function (p) {
    if (cats.indexOf(p.c) < 0) cats.push(p.c);
  });
  cats.forEach(function (c) {
    var g = document.createElement('optgroup');
    g.label = c;
    PROD.forEach(function (p) {
      if (p.c !== c) return;
      var o = document.createElement('option');
      o.value = p.h;
      o.textContent = p.t;
      g.appendChild(o);
    });
    sel.appendChild(g);
  });
  function eligeProducto(h) {
    estado.h = h;
    var p = actual();
    if (estado.k !== null && p.k.indexOf(estado.k) < 0) estado.k = p.k[0] || null;
    pinta();
  }

  sel.addEventListener('change', function () {
    eligeProducto(this.value);
  });

  /* --- cantidad: rango por escalones + campo libre --- */
  rango.min = 0;
  rango.max = TOPES.length - 1;
  rango.addEventListener('input', function () {
    estado.q = TOPES[Number(this.value)];
    campo.value = estado.q;
    pinta();
  });
  campo.addEventListener('input', function () {
    var v = parseInt(this.value, 10);
    estado.q = isNaN(v) || v < 1 ? 1 : v;
    pinta();
  });
  TOPES.forEach(function (q, i) {
    var b = document.createElement('button');
    b.type = 'button';
    b.textContent = fmt.format(q);
    b.dataset.q = q;
    b.addEventListener('click', function () {
      estado.q = q;
      campo.value = q;
      rango.value = i;
      pinta();
    });
    topes.appendChild(b);
  });

  /* --- precio con animación de conteo --- */
  var ref = null;
  var visto = 0;
  function animaPrecio(destino) {
    var caja = $('[data-innvolo-unitario]');
    if (quieto) {
      visto = destino;
      caja.innerHTML = cop(destino) + '<em>c/u</em>';
      return;
    }
    if (ref) cancelAnimationFrame(ref);
    var desde = visto;
    var t0 = null;
    var dur = 560;
    (function paso(t) {
      if (t0 === null) t0 = t;
      var k = Math.min(1, (t - t0) / dur);
      var e = 1 - Math.pow(1 - k, 3);
      visto = desde + (destino - desde) * e;
      caja.innerHTML = cop(visto) + '<em>c/u</em>';
      if (k < 1) ref = requestAnimationFrame(paso);
    })(performance.now());
  }

  function pintaTecnicas() {
    var p = actual();
    tecnicas.textContent = '';
    p.k.forEach(function (k) {
      if (!TEC[k]) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'innvolo-tecnica';
      b.setAttribute('aria-pressed', String(k === estado.k));
      b.innerHTML = TEC[k].n + '<em>' + cop(TEC[k].c) + '</em>';
      b.addEventListener('click', function () {
        estado.k = k;
        pinta();
      });
      tecnicas.appendChild(b);
    });
    var s = document.createElement('button');
    s.type = 'button';
    s.className = 'innvolo-tecnica';
    s.setAttribute('aria-pressed', String(estado.k === null));
    s.textContent = 'Sin marcar';
    s.addEventListener('click', function () {
      estado.k = null;
      pinta();
    });
    tecnicas.appendChild(s);
  }

  function pintaColores(p) {
    var caja = $('[data-innvolo-colores]');
    if (!caja) return;
    caja.textContent = '';
    (p.col || []).slice(0, 6).forEach(function (nom) {
      var i = document.createElement('i');
      if (COLORES[nom]) i.style.background = COLORES[nom];
      else i.style.backgroundImage = ARCOIRIS;
      i.title = nom;
      caja.appendChild(i);
    });
    if ((p.col || []).length > 6) {
      var e = document.createElement('em');
      e.textContent = '+' + (p.col.length - 6);
      caja.appendChild(e);
    }
  }

  function pintaEscalera(p, base, iT) {
    if (!escalera) return;
    escalera.textContent = '';
    TOPES.forEach(function (qq, i) {
      var r = calcula(p, qq, estado.k);
      var d = document.createElement('div');
      d.className = 'innvolo-peldano';
      d.dataset.activo = i === iT ? 'si' : 'no';
      var baja = base > 0 ? Math.round((1 - r.unit / base) * 100) : 0;
      d.innerHTML =
        '<span class="innvolo-peldano__q innvolo-cifra">' + fmt.format(qq) + ' unidades</span>' +
        '<b class="innvolo-peldano__u innvolo-cifra">' + cop(r.unit) + '</b>' +
        '<span class="innvolo-peldano__d innvolo-cifra">' +
        (i === 0 ? 'precio base' : '−' + baja + '% por unidad') +
        '</span>';
      escalera.appendChild(d);
    });
  }

  function pinta() {
    var p = actual();
    var q = estado.q;

    /* miniatura */
    var mini = $('[data-innvolo-mini]');
    if (mini) {
      if (p.img) {
        mini.src = p.img;
        mini.alt = p.t;
        mini.hidden = false;
      } else {
        mini.hidden = true;
      }
    }

    if (sel.value !== p.h) sel.value = p.h;

    $('[data-innvolo-meta]').textContent = p.c;
    $('[data-innvolo-cantidad-txt]').innerHTML =
      fmt.format(q) + ' <span>' + (q === 1 ? 'unidad' : 'unidades') + '</span>';
    if (String(campo.value) !== String(q)) campo.value = q;

    pintaColores(p);

    /* escalón activo */
    var iT = 0;
    for (var i = 0; i < TOPES.length; i++) {
      if (q >= TOPES[i]) iT = i;
    }
    rango.value = iT;
    rango.style.setProperty('--innvolo-pos', (iT / (TOPES.length - 1)) * 100 + '%');
    Array.prototype.forEach.call(topes.children, function (b) {
      b.setAttribute('aria-pressed', String(Number(b.dataset.q) === TOPES[iT]));
    });

    var minimo = p.moq || TOPES[0];
    var aviso = $('[data-innvolo-moq]');
    if (aviso) {
      aviso.hidden = q >= minimo;
      aviso.textContent =
        'Por debajo de ' + fmt.format(minimo) + ' unidades no producimos con marcación.';
    }

    pintaTecnicas();

    var r = calcula(p, q, estado.k);
    var dp = descProducto(q);
    var dm = descMarcacion(q);

    animaPrecio(r.unit);
    $('[data-innvolo-lb-prenda]').textContent =
      'Producto' + (dp ? '  −' + Math.round(dp * 100) + '%' : '');
    $('[data-innvolo-v-prenda]').textContent = cop(r.prenda);
    $('[data-innvolo-lb-marca]').textContent = estado.k && TEC[estado.k]
      ? TEC[estado.k].n + (dm ? '  −' + Math.round(dm * 100) + '%' : '')
      : 'Sin marcación';
    $('[data-innvolo-v-marca]').textContent = estado.k ? cop(r.marca) : '$0';
    $('[data-innvolo-lb-total]').textContent = 'Total por ' + fmt.format(q) + ' uds';
    $('[data-innvolo-v-total]').textContent = cop(r.unit * q);

    /* ahorro contra el precio de la cantidad base */
    var base = p.p + (estado.k && TEC[estado.k] ? TEC[estado.k].c : 0);
    var ah = $('[data-innvolo-ahorro]');
    if (ah) {
      if (r.unit < base - 1) {
        ah.hidden = false;
        ah.textContent =
          'Ahorra ' + cop((base - r.unit) * q) + ' frente al precio de ' +
          fmt.format(TOPES[0]) + ' unidades.';
      } else {
        ah.hidden = true;
      }
    }

    /* siguiente escalón */
    var sig = null;
    for (var j = 0; j < TOPES.length; j++) {
      if (TOPES[j] > q) {
        sig = TOPES[j];
        break;
      }
    }
    var emp = $('[data-innvolo-empuje]');
    if (emp) {
      emp.textContent = sig
        ? 'Con ' + fmt.format(sig) + ' unidades baja a ' + cop(calcula(p, sig, estado.k).unit) + ' c/u.'
        : 'Es el escalón más alto del catálogo.';
    }

    pintaEscalera(p, base, iT);

    /* el enlace a la ficha sigue al producto elegido */
    var ficha = $('[data-innvolo-ficha]');
    if (ficha && p.url) ficha.href = p.url;
  }

  /* --- API para que las tarjetas y el hero precarguen el cotizador --- */
  window.innvoloCotiza = function (handle) {
    var p = porHandle(handle);
    if (!p) return false;
    estado.h = p.h;
    estado.k = p.k[0] || null;
    pinta();
    raiz.scrollIntoView({ behavior: quieto ? 'auto' : 'smooth', block: 'start' });
    return true;
  };

  /* Progresivo: si el cotizador está en la página, el botón lo precarga.
     Si no lo está —la página de colección, por ejemplo— el enlace hace su
     trabajo normal y lleva a la ficha del producto. */
  document.addEventListener('click', function (ev) {
    var disparo = ev.target.closest('[data-innvolo-cotiza]');
    if (!disparo) return;
    if (window.innvoloCotiza(disparo.dataset.innvoloCotiza)) ev.preventDefault();
  });

  pinta();
})();
